import { render, staticRenderFns } from "./Factuur.vue?vue&type=template&id=31b24de7"
import script from "./Factuur.vue?vue&type=script&lang=js"
export * from "./Factuur.vue?vue&type=script&lang=js"
import style0 from "./Factuur.vue?vue&type=style&index=0&id=31b24de7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports